var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSync32(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sync/sync_32"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.1575 5.625H6.25V6.875H1.25V1.875H2.5V4.38313C4.25125 2.05688 7.03 0.625 10 0.625C15.1694 0.625 19.375 4.83063 19.375 10H18.125C18.125 5.52 14.48 1.875 10 1.875C7.22312 1.875 4.6375 3.32 3.1575 5.625ZM16.8425 14.375H13.75V13.125H18.75V18.125H17.5V15.6169C15.7487 17.9425 12.97 19.375 10 19.375C4.83063 19.375 0.625 15.1694 0.625 10H1.875C1.875 14.4806 5.52 18.125 10 18.125C12.7769 18.125 15.3625 16.68 16.8425 14.375Z",
    fill: "#2495F6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync32);
export default __webpack_public_path__ + "static/media/sync_32.faf6cd9bcd789f0ac13279f9119a882b.svg";
export { ForwardRef as ReactComponent };